export * from './product-details.component'
